import SentryService from "./sentryService";
import UserManager from "./manager/UserManager";

const CustomerService = {
  url: `${process.env.VUE_APP_API_URL}customers`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },

  create: async (data) => {
    try {
      const response = await fetch(`${CustomerService.url}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: CustomerService.headers,
      });

      return response;
    } catch (e) {
      return false;
    }
  },
  getSuppliers: async (data) => {
    try {
      const requestHeaders = {
        ...CustomerService.headers,
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      const response = await fetch(`${CustomerService.url}/get-suppliers`, {
        method: "GET",
        body: JSON.stringify(data),
        headers: requestHeaders,
      });

      return response;
    } catch (e) {
      return false;
    }
  },

  saveQuizAnswers: async (data) => {
    try {
      const response = await fetch(`${CustomerService.url}/save-quiz-answers`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: CustomerService.headers,
      });

      return response;
    } catch (e) {
      return false;
    }
  },
  createBusinessInfo: async (data) => {
    try {
      const requestHeaders = {
        ...CustomerService.headers,
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      const response = await fetch(
        `${CustomerService.url}/create-business-info`,
        {
          method: "POST",
          body: JSON.stringify(data),
          headers: requestHeaders,
        }
      );

      return response;
    } catch (e) {
      return false;
    }
  },

  handleShowMetaMapButton: async (field, value) => {
    try {
      const requestHeaders = {
        ...CustomerService.headers,
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      const response = await fetch(
        `${CustomerService.url}/handle-show-metamap-button`,
        {
          method: "POST",
          body: JSON.stringify({
            field: field,
            value: value,
          }),
          headers: requestHeaders,
        }
      );

      return response;
    } catch (e) {
      return false;
    }
  },

  async getReferralsBySupplier(data = {}) {
    try {
      const requestHeaders = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      const queryString = new URLSearchParams(data).toString();
      const response = await fetch(
        `${CustomerService.url}/get-referrals-by-supplier?${queryString}`,
        {
          method: "GET",
          headers: requestHeaders,
        }
      );

      return response;
    } catch (e) {
      return false;
    }
  },

  getByUser: async (id) => {
    try {
      const requestHeaders = {
        ...CustomerService.headers,
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      const response = await fetch(`${CustomerService.url}/get-by-user/${id}`, {
        method: "GET",
        headers: requestHeaders,
      });

      return response;
    } catch (e) {
      return false;
    }
  },

  searchCustomer: async (val) => {
    try {
      const requestHeaders = {
        ...CustomerService.headers,
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      const response = await fetch(`${CustomerService.url}/search/${val}`, {
        method: "GET",
        headers: requestHeaders,
      });

      return response;
    } catch (e) {
      return false;
    }
  },

  creditExtension: async () => {
    try {
      const requestHeaders = {
        ...CustomerService.headers,
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      const response = await fetch(`${CustomerService.url}/credit-extension`, {
        method: "POST",
        headers: requestHeaders,
      });

      return response;
    } catch (e) {
      return false;
    }
  },

  createStep1: async (data) => {
    try {
      const requestHeaders = {
        ...CustomerService.headers,
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      const response = await fetch(`${CustomerService.url}/create-step-1`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: requestHeaders,
      });

      return response;
    } catch (e) {
      return false;
    }
  },

  createBuyerCustomer: async (data) => {
    try {
      const requestHeaders = {
        ...CustomerService.headers,
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      const response = await fetch(
        `${CustomerService.url}/create-buyer-customer`,
        {
          method: "POST",
          body: JSON.stringify(data),
          headers: requestHeaders,
        }
      );

      return response;
    } catch (e) {
      return false;
    }
  },

  getAccountStatusByToken: async (token) => {
    try {
      const response = await fetch(
        `${CustomerService.url}/account-status/${token}`,
        {
          method: "GET",
          headers: CustomerService.headers,
        }
      );

      return response;
    } catch (e) {
      return false;
    }
  },

  exportAccountStatus: async (token) => {
    try {
      const response = await fetch(
        `${CustomerService.url}/export-account-status/${token}`,
        {
          method: "GET",
          headers: CustomerService.headers,
        }
      );

      return response;
    } catch (e) {
      return false;
    }
  },

  // Método para recomendar o referir proveedores desde clientes
  referSupplier: async (supplierData) => {
    try {
      const requestHeaders = {
        ...CustomerService.headers,
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      // Registramos la intención de recomendación en Sentry
      const user = UserManager.get();
      SentryService.captureMessage("Recomendación de proveedor", {
        level: "info",
        extra: {
          action: "supplier_recommendation",
          supplier_name: supplierData.name,
          supplier_phone: supplierData.phone,
          supplier_notes: supplierData.notes || "",
          recommender_id: user?.id,
          recommender_name: user?.name,
          recommender_business: user?.business_name,
          timestamp: new Date().toISOString(),
        },
      });

      const response = await fetch(`${CustomerService.url}/refer-supplier`, {
        method: "POST",
        body: JSON.stringify(supplierData),
        headers: requestHeaders,
      });

      return response;
    } catch (e) {
      SentryService.captureError(e, {
        action: "referSupplier",
        data: supplierData,
      });
      console.error("Error al recomendar proveedor:", e);
      return false;
    }
  },
};
export default CustomerService;
